import { LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { apiProgressBus, isLoading } from '../../services/apiProgress';

export const ApiProgressBar: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(isLoading());
    apiProgressBus.addEventListener('change', handler);
    return () => apiProgressBus.removeEventListener('change', handler);
  }, []);

  if (!visible) return null;
  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: 2,
      }}
    />
  );
};
